import React from "react"
import { MainColumn } from "../MainColumn"
import { Container } from "./style"
import { Content } from "../Content"
import { InternalTitleBlock } from "../InternalTitleBlock"
import Layout from "components/layout"
import { RelatedContent } from "../RelatedContent"
import SEO from "components/seo"

const InternalTemplate = ({
  tags,
  author,
  date,
  news,
  content,
  headerImg,
  title,
  textOptions,
  relatedContent,
  featuredImage,
  bulletPoints,
}) => {
  return (
    <Layout internal title={!headerImg ? null : title} headerImg={headerImg}>
      <SEO title={title} image={featuredImage} />
      <MainColumn>
        <Container>
          <Content>
            <InternalTitleBlock
              tags={tags}
              author={author}
              date={date}
              news={news}
              text={!headerImg ? title : textOptions.introStatement}
              bulletPoints={bulletPoints}
            />
            {content}
          </Content>
        </Container>
      </MainColumn>
      {relatedContent?.relatedPages && (
        <RelatedContent
          title={relatedContent.relatedHeader}
          pages={relatedContent.relatedPages}
        />
      )}
    </Layout>
  )
}

export default InternalTemplate
